import { useEffect, useState } from "react";
import { imgLib } from "../../assets";

const DynamicOffer = ({ name, affLogo }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [1, 2];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="dynamicOffer">
      {images.map((num, index) => {
        let imgComp = imgLib[`${name}_${num}`];
        return (
          <img
            key={index}
            src={imgComp}
            // src={`/assets/${lang}_${currency}_${num}.png`}
            alt={`offer`}
            className={`slideshow-image ${
              index === currentImage ? "active" : ""
            }`}
          />
        );
      })}
      {affLogo && (
        <img className="dynamic-offer-logo" src={affLogo} alt="Aff Logo" />
      )}
    </div>
  );
};

export default DynamicOffer;
